<template>
	<nav
		class="relative flex flex-wrap items-center justify-between xl:px-24 py-4 bg-gray-900 z-10">
		<div
			class="container xl:px-4 mx-auto flex flex-wrap items-center justify-between">
			<div
				class="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start">
				<router-link
					class="text-xl flex font-bold leading-relaxed mr-4 py-2 whitespace-nowrap uppercase text-white"
					to="/">
					<img
						class="w-8 h-8 mr-2"
						src="@/assets/Logo.png"
						alt="Logo" />
					<span>Pass2Peer</span>
				</router-link>
				<button
					class="text-white cursor-pointer text-xl leading-none border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
					type="button"
					@click="toggleNavbar()">
					<svg
						height="32px"
						style="enable-background: new 0 0 32 32"
						viewBox="0 0 32 32"
						width="32px"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
							style="fill: #fff" />
					</svg>
				</button>
			</div>
			<div
				v-bind:class="{ hidden: !showMenu, flex: showMenu }"
				class="lg:flex lg:flex-grow items-center">
				<ul class="flex flex-col lg:flex-row list-none ml-auto">
					<li class="nav-item">
						<router-link
							class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
							to="/">
							<span class="ml-2">Home</span>
						</router-link>
					</li>
					<li v-if="store.loggedIn" class="nav-item">
						<router-link
							class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
							to="/services">
							<span class="ml-2">Services</span>
						</router-link>
					</li>
					<li v-if="store.loggedIn" class="nav-item">
						<router-link
							class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
							to="/profile">
							<span class="ml-2">Profile</span>
						</router-link>
					</li>
					<li class="nav-item">
						<button
							class="ml-4 px-4 py-2 bg-purple-800 rounded-xl flex items-center text-xs uppercase font-bold leading-snug text-white hover:bg-opacity-75"
							@click="store.loggedIn ? logout() : login()">
							<span>{{ store.loggedIn ? 'Logout' : 'Login' }}</span>
						</button>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
import Vue from 'vue'
import { store } from './store'

export default {
	name: 'Header',
	data() {
		return {
			showMenu: false,
			store
		}
	},
	methods: {
		toggleNavbar() {
			this.showMenu = !this.showMenu
		},
		login() {
			this.$router.push('/login')
		},
		logout() {
			store.loggedIn = false
			localStorage.removeItem('token')
			this.$router.push('/login')
			Vue.$toast.success('Logged out successfully', { position: 'top' })
		}
	}
}
</script>
